export enum SortOptions {
    VACANCY_ASCENDING = "vacancy:asc",
    VACANCY_DESCENDING = "vacancy:desc",
    PRICE_ASCENDING = "price:asc",
    PRICE_DESCENDING = "price:desc",
    AREA_ASCENDING = "area:asc",
    AREA_DESCENDING = "area:desc",
}

export enum CountryCodes {
    US = "US",
    CA = "CA",
    UK = "UK",
    AU = "AU",
}

export enum FunnelType {
    RESERVE = "reserve",
    RENT = "rent",
    QUOTE = "quote",
}

export enum QuoteType {
    RESERVE = "reserve",
    CALL = "call",
}

export enum ButtonLayout {
    COMBINED = "combined",
    SEPARATE = "separate",
}

export enum TableLayout {
    GRID = "grid",
    ROW = "row",
}

export enum WidgetLayout {
    LAYOUT_1 = "layout_1",
    LAYOUT_2 = "layout_2",
    MARKET = "market",
}

export enum AppLocation {
    DIALOG = "dialog",
    ACCORDION = "accordion",
    EXTERNAL = "external",
    DRAWER = "drawer",
}

export enum Step {
    VBP = "vbp",
    RENT_RESERVE_QUOTE = "rent-reserve-quote",
    FUNNEL = "funnel",
}

export enum ReservationType {
    SOFT = "soft",
    HARD = "hard",
}

export enum UnitActionMode {
    RESERVE_ONLY = "reserve_only",
    CLICK_TO_CALL = "click_to_call",
}